// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"58009022","732":"d3252c7f","977":"ad07c868"}[chunkId] + ".chunk.js";
};